import _debounce from "lodash/debounce";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./ChatMessageList.scss";
import { getChatTimeMarker } from "@/common/dateUtils";
import ChatMessageItem from "./ChatMessageItem";
import { simpleAlert, successAlert } from "@/pages/modules/alerts";
import { assert } from "@/common/assert";
import { wait } from "@/pages/base/asyncUtils";
import store from "@/store/store";
import { saveContactScrollTop } from "@/store/chat/contacts/Actions";
import PhotoSlider from "./PhotoSlider";
import { isMarker } from "@/store/chat/messages/messagesWithMarker";
import { shouldMessageBeVisible } from "./chatRoomUtils";
import { CompanyMemberApiApi } from "@/apis/api/CompanyMemberApiApi";
var memberApi = new CompanyMemberApiApi();

function safeLast(arr) {
  if (!arr) return;
  var last = arr[arr.length - 1];
  return last;
}

var SCROLL_EVENT_NAMESPACE = "scroll.chatmessagelist.fht360";

var ChatMessageList =
/** @class */
function (_super) {
  __extends(ChatMessageList, _super);

  function ChatMessageList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showPhotoSlider: false
    };
    _this.scrollElement = /*#__PURE__*/React.createRef();

    _this.scrollMessagePanelToBottom = function (animated) {
      if (animated === void 0) {
        animated = true;
      }

      return __awaiter(_this, void 0, Promise, function () {
        var imagesNotLoaded, d, notLoadedImagCount, untilAllImagesInListAreLoadedSoThatHeightIsDetermined, maxTimeOut, $d, scrollTop;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              imagesNotLoaded = [];
              d = this.scrollElement && this.scrollElement.current;
              assert(d, "scroll el falsy");
              $(d).find("img").each(function (idx, el) {
                if (!el.clientWidth) {
                  imagesNotLoaded.push(el);
                }
              });
              notLoadedImagCount = imagesNotLoaded.length;
              if (!notLoadedImagCount) return [3
              /*break*/
              , 2];
              untilAllImagesInListAreLoadedSoThatHeightIsDetermined = new Promise(function (res) {
                var e_1, _a;

                var onLoadOrError = function onLoadOrError() {
                  notLoadedImagCount--;

                  if (notLoadedImagCount === 0) {
                    res();
                  }
                };

                try {
                  for (var imagesNotLoaded_1 = __values(imagesNotLoaded), imagesNotLoaded_1_1 = imagesNotLoaded_1.next(); !imagesNotLoaded_1_1.done; imagesNotLoaded_1_1 = imagesNotLoaded_1.next()) {
                    var img = imagesNotLoaded_1_1.value;
                    $(img).one("load", onLoadOrError).one("error", onLoadOrError);
                  }
                } catch (e_1_1) {
                  e_1 = {
                    error: e_1_1
                  };
                } finally {
                  try {
                    if (imagesNotLoaded_1_1 && !imagesNotLoaded_1_1.done && (_a = imagesNotLoaded_1["return"])) _a.call(imagesNotLoaded_1);
                  } finally {
                    if (e_1) throw e_1.error;
                  }
                }
              });
              maxTimeOut = wait(2000);
              return [4
              /*yield*/
              , Promise.race([maxTimeOut, untilAllImagesInListAreLoadedSoThatHeightIsDetermined])];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              $d = $(d);
              scrollTop = d.scrollHeight + "px";
              $d.animate({
                scrollTop: scrollTop
              }, animated ? 500 : 0);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.onClickImage = function (message) {
      _this.setState({
        showPhotoSlider: true,
        clickedImageMessage: message
      });
    };

    _this.onCloseSlider = function () {
      _this.setState({
        showPhotoSlider: false
      });
    };

    _this.onJoinCompany = function (model) {
      return __awaiter(_this, void 0, Promise, function () {
        var value;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , memberApi.companyMemberApiApply({
                model: model
              })];

            case 1:
              value = _a.sent();

              if (value && value.Id && value.Id > 0) {
                void successAlert("申请成功!");
              } else {
                void simpleAlert("申请失败!");
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  ChatMessageList.prototype.componentDidMount = function () {
    var _this = this;

    var el = this.scrollElement.current;
    assert(el, "cur el falsy");
    var $el = $(el);

    var onScrollDebounced = _debounce(function () {
      var scrollTop = $el.scrollTop();
      var currentContact = _this.props.currentContact;
      assert(currentContact, "cc falsy");
      store.dispatch(saveContactScrollTop(currentContact, scrollTop));
    }, 500);

    $el.on(SCROLL_EVENT_NAMESPACE, onScrollDebounced);
    this.scrollMessagePanelToBottom(false);
  };

  ChatMessageList.prototype.componentWillUnmount = function () {
    $(this.scrollElement.current).off(SCROLL_EVENT_NAMESPACE);
  };

  ChatMessageList.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a, _b;

    assert(this.scrollElement.current, "scroll el falsy"); //the way we generate marker gurrantees that the last item cannot be a marker so we cast them below.

    var prevLastMessage = safeLast(prevProps.currentContactMessages);
    var currLastMessage = safeLast(this.props.currentContactMessages);
    var isSameAsPreviousContact = prevProps.currentContact && this.props.currentContact && prevProps.currentContact.chatId.encode() === this.props.currentContact.chatId.encode();

    if (!isSameAsPreviousContact) {
      var hasValidScrollTop = typeof this.props.currentContact.scrollTop !== "undefined";

      if (hasValidScrollTop) {
        this.scrollElement.current.scrollTop = this.props.currentContact.scrollTop;
      } else {
        void this.scrollMessagePanelToBottom(false);
      }

      return;
    } //same contact


    assert(prevProps.currentContact && this.props.currentContact, "gotta have both truthy");
    var lastMessageChanged = (currLastMessage === null || currLastMessage === void 0 ? void 0 : currLastMessage.id) !== (prevLastMessage === null || prevLastMessage === void 0 ? void 0 : prevLastMessage.id);
    var previouslyNoHistory = !((_a = prevProps.currentContact.messageHistoryInfo) === null || _a === void 0 ? void 0 : _a.earliestHistoryTimestamp);
    var nowHasHistory = (_b = this.props.currentContact.messageHistoryInfo) === null || _b === void 0 ? void 0 : _b.earliestHistoryTimestamp;
    var initialLoadOfHistory = previouslyNoHistory && nowHasHistory;

    if (lastMessageChanged || initialLoadOfHistory) {
      var shouldAnimate = !initialLoadOfHistory;
      void this.scrollMessagePanelToBottom(shouldAnimate);
    }
  };

  ChatMessageList.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        myself = _a.myself,
        currentContact = _a.currentContact,
        currentContactMessages = _a.currentContactMessages;
    return _jsxs("div", __assign({
      ref: this.scrollElement,
      className: "chat-message-list"
    }, {
      children: [_jsx("ul", __assign({
        className: "chat-message-list__inner"
      }, {
        children: currentContactMessages.map(function (message) {
          return isMarker(message) ? _jsx("li", __assign({
            className: "chat-message-list__inner-marker"
          }, {
            children: _jsx("span", __assign({
              className: "chat-message-list__inner-marker-text"
            }, {
              children: getChatTimeMarker(message.ts)
            }), void 0)
          }), message.ts.toString()) : shouldMessageBeVisible(message, myself) && _jsx(ChatMessageItem, {
            message: message,
            contact: currentContact,
            myself: myself,
            onJoinCompany: _this.onJoinCompany,
            onClickImage: _this.onClickImage
          }, message.id);
        })
      }), void 0), this.state.showPhotoSlider && _jsx(PhotoSlider, {
        onCloseSlider: this.onCloseSlider,
        clickedImageMessage: this.state.clickedImageMessage,
        currentContactMessages: this.props.currentContactMessages.filter(function (m) {
          return !isMarker(m);
        })
      }, void 0)]
    }), void 0);
  };

  return ChatMessageList;
}(React.Component);

export default ChatMessageList;